https://sorokdvaonline.wixsite.com/draft/ За полной документацией по API, включая примеры кода, зайдите на http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});